import { useQuery } from "@tanstack/react-query";
import { toastServerError } from "helpers";
import { ApiError, ApiServiceError } from "libs/api";
import { QueryOptions } from "libs/reactQuery";

import { AffinityRule } from "../../recommendation.types";
import { requestGetAffinityRules } from "./getAffinityRules.request";

const useAffinityRules = (
  options?: QueryOptions<AffinityRule[], ApiServiceError<ApiError>>
) => {
  const { data: rules, ...rest } = useQuery({
    queryKey: ["recommendation", "affinity", "list"],
    queryFn: requestGetAffinityRules,
    onError: toastServerError,
    ...options
  });

  return { rules: rules ?? [], ...rest };
};

export default useAffinityRules;
